<!--<p-autoComplete *ngIf="viewAutoComplete"-->
<!--        inputStyleClass="form-control"-->
<!--        [style]="{'width':'100%'}"-->
<!--        [(ngModel)]="inseridos"-->
<!--        [suggestions]="results"-->
<!--        (completeMethod)="pesquisaPalavraChave($event)"-->
<!--        (onUnselect)="excluirPalavraChave($event)"-->
<!--        (onSelect)="inserirPalavraChave($event)"-->
<!--        (onKeyUp)="onKeyUp($event)"-->
<!--        [multiple]="true"-->
<!--        [minLength]="3"-->
<!--        [unique]="true"-->
<!--        field="palavra_chave.descricao"-->
<!--        [autofocus]="false">-->
<!--    <ng-template let-country pTemplate="item">-->
<!--        <div class="country-item">-->
<!--            <div>{{country.palavra_chave.descricao}}</div>-->
<!--        </div>-->
<!--    </ng-template>-->
<!--</p-autoComplete>-->

<div class="row p-2">
    <div class="col">
        <input class="form-control" type="text" style="width: 300px; float: left;" #palavra/>
        <button type="button" (click)="onKeyUp(this.palavra)" class="btn btn-default" value="Incluir" title="Incluir palavra chave">
            <span>Incluir</span>
        </button>
    </div>
</div>
<div class="row p-2 mt-2 mb-4">
    <span class="ng-tns-c92-1 p-autocomplete p-component p-autocomplete-multiple" style="width: 100%;">
        <ul class="p-autocomplete-multiple-container p-component p-inputtext ng-tns-c92-1 ng-star-inserted" style="list-style: none; overflow: hidden;">
            <li *ngFor="let item of inseridos; let i = index"
                (click)="excluirPalavraChave(item,i)"
                style="float: left;"
                class="p-autocomplete-token ng-tns-c92-1 ng-star-inserted">
                <span class="p-autocomplete-token-label ng-tns-c92-1 ng-star-inserted">{{item.palavra_chave.descricao}}</span>
                <span class="p-autocomplete-token-icon pi pi-times-circle ng-tns-c92-1 ng-star-inserted"></span>
            </li>
        </ul>
    </span>
</div>